// extracted by mini-css-extract-plugin
export var active = "_88-1";
export var activeSubdued = "_88-2";
export var compact = "_88-3";
export var fill = "_88-6";
export var pulse = "_88-4";
export var settingHighlightPulse = "_88-5";
export var wrapper = "_88-0";